module.exports = __webpack_public_path__ + "static/media/rider_large.9d01c8b5.svg";